function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInactivate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(90.588236%,60.392159%,17.647059%)",
      fillOpacity: 1
    },
    d: "M 4.800781 0 L 19.199219 0 C 21.851562 0 24 2.148438 24 4.800781 L 24 19.199219 C 24 21.851562 21.851562 24 19.199219 24 L 4.800781 24 C 2.148438 24 0 21.851562 0 19.199219 L 0 4.800781 C 0 2.148438 2.148438 0 4.800781 0 Z M 4.800781 0 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 10,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(100%,100%,100%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 79.996745 50 C 79.996745 33.43099 66.56901 20.003255 50 20.003255 C 33.43099 20.003255 20.003255 33.43099 20.003255 50 C 20.003255 66.56901 33.43099 79.996745 50 79.996745 C 66.56901 79.996745 79.996745 66.56901 79.996745 50 Z M 79.996745 50 ",
    transform: "matrix(0.24,0,0,0.24,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1,
      strokeWidth: 10,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      stroke: "rgb(100%,100%,100%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 29.996745 70.003255 L 70.003255 29.996745 ",
    transform: "matrix(0.24,0,0,0.24,0,0)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInactivate);
export default __webpack_public_path__ + "static/media/inactivate.3b46056d9542ae61cd28c76513841641.svg";
export { ForwardRef as ReactComponent };